import { Radio as RadioPrimitive } from '@base-ui/react/radio';
import { RadioGroup as RadioGroupPrimitive } from '@base-ui/react/radio-group';
import { css } from 'aphrodite';
import * as React from 'react';
import { s } from './styles';

type RadioGroupProps<Value> = AphroditeStyled<RadioGroupPrimitive.Props<Value>>;

type RadioGroupItemProps<Value> = AphroditeStyled<RadioPrimitive.Root.Props<Value>> & {
	size?: 'md' | 'lg';
};

// forwardRef erases the Value type parameter, so each cast restores the generic call signature.
const RadioGroup = React.forwardRef(function RadioGroup<Value>(
	{ styles = [], ...props }: Omit<RadioGroupProps<Value>, 'ref'>,
	ref: React.ForwardedRef<HTMLDivElement>
) {
	return <RadioGroupPrimitive ref={ref} data-slot='radio-group' className={css(s.group, ...styles)} {...props} />;
}) as <Value>(props: RadioGroupProps<Value>) => React.JSX.Element;

const RadioGroupItem = React.forwardRef(function RadioGroupItem<Value>(
	{ styles = [], size = 'md', ...props }: Omit<RadioGroupItemProps<Value>, 'ref'>,
	ref: React.ForwardedRef<HTMLSpanElement>
) {
	return (
		<RadioPrimitive.Root ref={ref} data-slot='radio-group-item' className={css(s.item, s[size], ...styles)} {...props}>
			<RadioPrimitive.Indicator
				data-slot='radio-group-indicator'
				className={css(s.indicator, size === 'lg' ? s.lgIndicator : s.mdIndicator)}
			/>
		</RadioPrimitive.Root>
	);
}) as <Value>(props: RadioGroupItemProps<Value>) => React.JSX.Element;

export { RadioGroup, RadioGroupItem };
export type { RadioGroupItemProps, RadioGroupProps };
